import React, { useState, useEffect, useRef } from 'react'
import classNames from 'classnames'
import { colorThemes } from './constants'
import { hexToObject } from '../../utils/format'
import ColorPickerWidget from './components/ColorPickerWidget'
import PickerEyeDrop from './components/PickerEyeDrop'
import PickerSwatch from './components/PickerSwatch'
import { VuiPopOver } from '@topkamera/viso-ui'
import './style.scss'

const ColorPicker = ({
  theme = 'viso', colorHex, isDisabled, onChange, offset = 8, reversedActions, defaultAlpha = 1, mode = 2, popoverElementId = 'popoverRoot', position = 'right', alignment = 'center',
}) => {
  const getPreset = colorThemes[theme]
  const getHex = colorHex || getPreset[0]
  const generateColor = hexToObject(getHex)
  const [color, setColor] = useState(generateColor)
  const [changedColor, setChangedColor] = useState(null)
  const [showPickerWidget, setShowPickerWidget] = useState(false)
  const { rgb } = color
  const anchorRef = useRef(null)

  useEffect(() => {
    setColor(generateColor)
  }, [colorHex])

  useEffect(() => {
    if (isDisabled && showPickerWidget) {
      setShowPickerWidget(false)
    }
  }, [isDisabled, showPickerWidget])

  const handleChange = (newColor) => {
    if (isDisabled) return
    setColor(newColor)
    onChange && onChange(newColor)
  }

  const togglePickerWidget = () => {
    if (isDisabled) return
    setShowPickerWidget(!showPickerWidget)
  }

  const openPickerWidget = () => {
    if (isDisabled) return
    setShowPickerWidget(true)
  }

  return (
    <div className='viso-color-picker' style={isDisabled ? { pointerEvents: 'none' } : undefined} aria-disabled={isDisabled}>
      <div
        className={classNames(
          'viso-color-picker__actions',
          reversedActions && 'viso-color-picker__actions--reversed',
          isDisabled && 'viso-color-picker__actions--disabled'
        )}
        ref={anchorRef}
      >
        <PickerSwatch
          color={`rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${rgb.a})`}
          alpha={rgb.a}
          onClick={openPickerWidget}
          disabled={isDisabled}
        />
        <PickerEyeDrop
          mode={mode}
          onOpen={isDisabled ? undefined : openPickerWidget}
          onChange={isDisabled ? undefined : ((picked) => {
            const updatedRgb = { ...picked.rgb, a: rgb.a }
            handleChange({ ...picked, rgb: updatedRgb })
          })}
          disabled={isDisabled}
        />
      </div>
      <VuiPopOver
        onClose={togglePickerWidget}
        elementId={popoverElementId}
        isOpen={showPickerWidget}
        anchorRef={anchorRef}
        alignment={alignment}
        position={position}
        animation='fade'
        offset={offset}
      >
        <ColorPickerWidget
          color={color}
          defaultAlpha={defaultAlpha}
          onChange={handleChange}
          presetColors={getPreset}
          onClose={togglePickerWidget}
          setChangedColor={setChangedColor}
          changedColor={changedColor}
        />
      </VuiPopOver>
    </div >
  )
}

export default ColorPicker